// this style is in right a panel, out of the feature scope, so use as the global pattern
export const uetTagSelectorStyles = (theme, { width = 800 } = {}) => ({
  '.uet-tag-selector': {
    width,

    '& .col-sm-4': {
      lineHeight: '32px',
      width: '100%',

      '& .link-manage-tag': {
        marginLeft: 20,
        float: 'right',
      },
    },

    '& .create-tag-form': {
      border: '1px solid #605E5C',
      margin: '10px 0px',
      paddingBottom: 10,

      '& .panel': {
        border: 0,
        boxShadow: 'none',

        '& .form-group': {
          margin: 0,
        },

        '& .control-label': {
          textAlign: 'left',
        },

        '& textarea': {
          resize: 'none',
        },

        '& .col-sm-8': {
          padding: '0px 15px',
          width: '100%',
        },
      },
    },
  },
});
